import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import LaCartePage from "./pages/LaCartePage";
import WeeklyMenusPage from "./pages/WeeklyMenusPage";
import EventsPage from "./pages/EventsPage";
import ReservePage from "./pages/ReservePage";
import TerracePage from "./pages/TerracePage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ProfilePage from "./pages/ProfilePage";
import QRMenuPage from "./pages/QRMenuPage";
import AuthCallback from "./pages/AuthCallback";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminReservations from "./admin/AdminReservations";
import AdminMenu from "./admin/AdminMenu";
import AdminWeekly from "./admin/AdminWeekly";
import AdminPlanning from "./admin/AdminPlanning";
import AdminCustomers from "./admin/AdminCustomers";
import AdminPromotions from "./admin/AdminPromotions";
import AdminSettings from "./admin/AdminSettings";
import AdminWallets from "./admin/AdminWallets";
import AdminPayments from "./admin/AdminPayments";
import AdminMarketing from "./admin/AdminMarketing";

const ADMIN_ROLES = ["admin", "super_admin", "staff"];

function ProtectedRoute({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-[#D4AF37]">Chargement…</div>;
  }
  if (user === false) return <Navigate to="/connexion" replace />;
  if (adminOnly && !ADMIN_ROLES.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation(); // read hash from here, not window.location.hash (not reactive)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Navigate to="/la-carte" replace />} />
        <Route path="/la-carte" element={<LaCartePage />} />
        <Route path="/menus-semaine" element={<WeeklyMenusPage />} />
        <Route path="/soirees" element={<EventsPage />} />
        <Route path="/reserver" element={<ReservePage />} />
        <Route path="/terrasse-evenements" element={<TerracePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/connexion" element={<LoginPage />} />
        <Route path="/reinitialiser-mot-de-passe" element={<ResetPasswordPage />} />
        <Route path="/profil" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
      </Route>
      <Route path="/qr-menu" element={<QRMenuPage />} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
        <Route index element={<AdminDashboard />} />
        <Route path="dashboard" element={<Navigate to="/admin" replace />} />
        <Route path="reservations" element={<AdminReservations />} />
        <Route path="menu" element={<AdminMenu />} />
        <Route path="menus-semaine" element={<AdminWeekly />} />
        <Route path="planning" element={<AdminPlanning />} />
        <Route path="clients" element={<AdminCustomers />} />
        <Route path="wallets" element={<AdminWallets />} />
        <Route path="paiements" element={<AdminPayments />} />
        <Route path="marketing" element={<AdminMarketing />} />
        <Route path="promotions" element={<AdminPromotions />} />
        <Route path="parametres" element={<AdminSettings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="noise-bg min-h-screen bg-[#050505]">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
